import { render, staticRenderFns } from "./ModeratorQuestionAdmin.vue?vue&type=template&id=5fcfa2f5"
import script from "./ModeratorQuestionAdmin.vue?vue&type=script&lang=js"
export * from "./ModeratorQuestionAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModeratorQuestionAdmin.vue?vue&type=style&index=0&id=5fcfa2f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports